// extracted by mini-css-extract-plugin
export default {"page":"ZpjAZ","content":"QHnBX","infoConsent":"G6HAj"};